<template>
  <div class="list-section">
    <!-- 搜索表单 -->
    <div class="search-bg">
      <el-form :inline="true" :model="searchForm">
        <el-row :gutter="22">
          <el-col :span="5">
            <el-form-item
              :label="$t('proxy.text62') + '：'"
              class="search-label"
            >
              <el-input
                v-model="searchForm.agentName"
                placeholder=""
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$t('proxy.text153') + '：'"
              class="selector-search-label"
            >
              <el-select v-model="searchForm.status" placeholder="" clearable>
                <el-option :label="$t('proxy.text178')" value="10" />
                <el-option :label="$t('proxy.text179')" value="20" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              :label="$t('proxy.text267') + '：'"
              class="search-label"
            >
              <el-input
                v-model="searchForm.contactPhone"
                placeholder=""
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" @click="onSearch" class="search-button">{{
              $t("proxy.text13")
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 新增代理按钮 -->
    <div style="padding-bottom: 16px" v-if="canAddSubProxy">
      <el-button
        type="primary"
        @click="openAddAgentDialog"
        class="add-button"
        >{{ $t("proxy.text64") }}</el-button
      >
    </div>

    <!-- 添加/编辑代理弹窗 -->
    <el-dialog
      :title="dialogTitle"
      v-model="addAgentDialogVisible"
      width="480px"
    >
      <el-form :model="addAgentForm" label-width="160px">
        <el-form-item :label="$t('proxy.text62') + '：'" required>
          <el-input v-model="addAgentForm.name" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('proxy.text27') + '：'" required>
          <el-input v-model="addAgentForm.contracter" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('proxy.text267') + '：'" required>
          <el-input
            v-model="addAgentForm.contacterphone"
            placeholder=""
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('proxy.text269') + '：'">
          <el-select
            v-model="addAgentForm.highLevelGroupIds"
            placeholder=""
            multiple
          >
            <el-option
              v-for="group in ruleGroups.high"
              :key="group.rulesGroupID"
              :label="group.rulesGroupName"
              :value="group.rulesGroupID"
              :disabled="group.disabled"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('proxy.text270') + '：'">
          <el-select
            v-model="addAgentForm.normalLevelGroupIds"
            placeholder=""
            multiple
          >
            <el-option
              v-for="group in ruleGroups.normal"
              :key="group.rulesGroupID"
              :label="group.rulesGroupName"
              :value="group.rulesGroupID"
              :disabled="group.disabled"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('proxy.text271') + '：'">
          <el-select
            v-model="addAgentForm.lowLevelGroupIds"
            placeholder=""
            multiple
          >
            <el-option
              v-for="group in ruleGroups.low"
              :key="group.rulesGroupID"
              :label="group.rulesGroupName"
              :value="group.rulesGroupID"
              :disabled="group.disabled"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="$t('proxy.text272') + '：'"
          required
          style="margin-bottom: 0"
        >
          <el-input
            :disabled="addAgentForm.proxyId !== 0"
            v-model="addAgentForm.userId"
            placeholder=""
          ></el-input>
          <div
            style="
              color: #ef383c;
              font-size: 12px;
              margin-top: 4px;
              margin-bottom: 0;
            "
          >
            {{ $t("proxy.text268") }}
          </div>
        </el-form-item>
        <el-form-item :label="$t('proxy.text153') + '：'" required>
          <el-radio-group v-model="addAgentForm.status">
            <el-radio label="正常">{{ $t("proxy.text47") }}</el-radio>
            <el-radio label="禁用">{{ $t("proxy.text48") }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('proxy.text76') + '：'">
          <el-input
            type="textarea"
            v-model="addAgentForm.note"
            placeholder=""
          ></el-input>
        </el-form-item>
      </el-form>
      <span class="dialog-footer">
        <el-button @click="addAgentDialogVisible = false">{{
          $t("proxy.text167")
        }}</el-button>
        <el-button type="primary" @click="saveAgent">{{
          $t("myAccount.text118")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 表格 -->
    <div class="table-container">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          prop="proxyid"
          :label="$t('proxy.text65')"
          align="center"
          min-width="100px"
        />
        <el-table-column
          prop="name"
          :label="$t('proxy.text62')"
          align="center"
          min-width="150px"
        />
        <el-table-column
          prop="groupName"
          :label="$t('proxy.text229')"
          align="center"
          min-width="150px"
        >
          <template #default="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.groupName"
              placement="top"
            >
              <span class="ellipsis-text">{{ scope.row.groupName }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="contracter"
          :label="$t('proxy.text27')"
          align="center"
          min-width="150px"
        />
        <el-table-column
          prop="contacterphone"
          :label="$t('proxy.text267')"
          align="center"
          min-width="150px"
        />
        <el-table-column
          prop="statusStr"
          :label="$t('proxy.text153')"
          align="center"
          min-width="100px"
        />
        <el-table-column
          prop="userCount"
          :label="$t('proxy.text66')"
          align="center"
          min-width="100px"
        />
        <el-table-column
          prop="openCount"
          :label="$t('proxy.text67')"
          align="center"
          min-width="150px"
        />
        <el-table-column
          prop="commSum"
          :label="$t('fundHistory.text50')"
          align="center"
          min-width="150px"
        />
        <el-table-column
          :label="$t('proxy.text139')"
          align="center"
          min-width="200px"
          fixed="right"
        >
          <template v-slot="scope">
            <el-button type="text" @click="editAgent(scope.row)">{{
              $t("proxy.text68")
            }}</el-button>
            <el-button
              class="link-button"
              type="text"
              @click="goToAgentLinks(scope.row)"
              >{{ $t("proxy.text211") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <el-pagination
      @current-change="handlePageChange"
      :current-page="currentPage"
      @size-change="handleSizeChange"
      :page-size="pageSize"
      :total="totalEntries"
      :page-sizes="[10, 50, 100, 200]"
      layout="total, prev, pager, next, sizes"
      class="pagination-container"
    />
  </div>
</template>


<script>
import { ref, reactive, onMounted } from "vue";
import apiService from "@/api/request";
import { ElMessage } from "element-plus";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

export default {
  setup() {
    const router = useRouter();
    const { t } = useI18n();
    const dialogTitle = ref(t("proxy.text64")); // 控制弹窗标题
    const searchForm = reactive({
      agentName: "",
      status: "",
      contactPhone: "",
    });

    const addAgentForm = reactive({
      proxyId: null, // 新增时为空，编辑时赋值
      name: "",
      contracter: "",
      contacterphone: "",
      highLevelGroupIds: "", // 高等级- 后面改为低点差
      normalLevelGroupIds: "", // 普通等级-后面改为普通点差
      lowLevelGroupIds: "", // 低等级-后面改为高点差
      userId: "",
      status: "正常",
      note: "",
    });

    const tableData = ref([]);
    const ruleGroups = reactive({
      high: [],
      normal: [],
      low: [],
    });
    const currentPage = ref(1);
    const pageSize = ref(10);
    const totalEntries = ref(0);
    const addAgentDialogVisible = ref(false);
    const canAddSubProxy = ref(false); // 用于控制按钮的显示或隐藏

    // 获取用户信息，判断是否可以添加代理
    const fetchUserInformation = async () => {
      try {
        const response = await apiService.UserInformation(); // 请求接口获取用户信息
        if (response.status === 1) {
          canAddSubProxy.value = response.data.canAddSubProxy; // 设置 canAddSubProxy 字段
        } else {
          ElMessage.error(response.message); // 处理接口失败
        }
      } catch (error) {
        console.error(error);
      }
    };

    const fetchRuleGroups = async () => {
      try {
        const { data } = await apiService.proxyProxySubRulesGroupList();
        ruleGroups.high = data.list.filter(
          (group) => group.rulesGroupLevel === 1
        );
        ruleGroups.normal = data.list.filter(
          (group) => group.rulesGroupLevel === 2
        );
        ruleGroups.low = data.list.filter(
          (group) => group.rulesGroupLevel === 3
        );
      } catch (error) {
        console.error("获取规则组失败:", error);
      }
    };

    const fetchData = () => {
      const params = {
        page: currentPage.value,
        limit: pageSize.value,
        ProxyName: searchForm.agentName,
        status: searchForm.status,
        phone: searchForm.contactPhone,
      };
      apiService.proxySubProxyList(params).then((response) => {
        tableData.value = response.data.list;
        totalEntries.value = response.data.count;
      });
    };

    const onSearch = () => {
      currentPage.value = 1;
      fetchData();
    };

    const saveAgent = async () => {
      // 检查表单是否填写完整
      if (
        addAgentForm.name === "" ||
        addAgentForm.contracter === "" ||
        addAgentForm.contacterphone === "" ||
        addAgentForm.userId === "" ||
        !addAgentForm.status
      ) {
        ElMessage.error(t("proxy.text177"));
        return;
      }

      if (
        !addAgentForm.highLevelGroupIds.length &&
        !addAgentForm.normalLevelGroupIds.length &&
        !addAgentForm.lowLevelGroupIds.length
      ) {
        // 提示：规则组至少选择1个
        ElMessage.error(t("proxy.text312"));
        return;
      }

      // 检查用户ID是否为数字，如果不是数字则提示错误
      if (isNaN(addAgentForm.userId)) {
        ElMessage.error(t("proxy.text290"));
        return;
      }

      // 将选中的组ID数组用逗号连接成字符串
      const highLevelGroupIds =
        addAgentForm.highLevelGroupIds.length > 0
          ? addAgentForm.highLevelGroupIds.join(",")
          : "";
      const normalLevelGroupIds =
        addAgentForm.normalLevelGroupIds.length > 0
          ? addAgentForm.normalLevelGroupIds.join(",")
          : "";
      const lowLevelGroupIds =
        addAgentForm.lowLevelGroupIds.length > 0
          ? addAgentForm.lowLevelGroupIds.join(",")
          : "";

      const params = {
        proxyId: addAgentForm.proxyId, // 编辑时传递 proxyId
        name: addAgentForm.name,
        contracter: addAgentForm.contracter,
        contacterphone: addAgentForm.contacterphone,
        highLevelGroupIds, // 逗号拼接后的值
        normalLevelGroupIds, // 逗号拼接后的值
        lowLevelGroupIds, // 逗号拼接后的值
        userId: addAgentForm.userId,
        status: addAgentForm.status === "正常" ? 10 : 20, // 根据单选值处理状态
        note: addAgentForm.note,
      };

      console.log("保存代理信息:", params);

      try {
        const response = await apiService.proxySaveProxyInfo(params);
        if (response.status === 1) {
          ElMessage.success(t("proxy.text243")); // 显示保存成功消息
          addAgentDialogVisible.value = false;
          setTimeout(() => {
            fetchData(); // 重新获取数据
          }, 1000); // 延时1秒后获取最新数据
        } else {
          ElMessage.error(response.message);
        }
      } catch (error) {
        ElMessage.error(t("proxy.text244"));
      }
    };

    const goToAgentLinks = (agent) => {
      router.push({
        name: "agentLinks",
        query: {
          proxyId: agent.proxyid, // 可以携带代理ID作为查询参数
          activeMenu: "agentlist",
        },
      });
    };

    const openAddAgentDialog = async () => {
      if (!canAddSubProxy.value) {
        return;
      }

      dialogTitle.value = ref(t("proxy.text64")); // 设置标题为新增代理
      await fetchRuleGroups(); // 请求规则组信息
      addAgentForm.proxyId = 0; // 新增传0
      addAgentForm.name = "";
      addAgentForm.contracter = "";
      addAgentForm.contacterphone = "";
      addAgentForm.highLevelGroupIds = "";
      addAgentForm.normalLevelGroupIds = "";
      addAgentForm.lowLevelGroupIds = "";
      addAgentForm.userId = "";
      addAgentForm.status = "正常"; // 默认选择“正常”
      addAgentForm.note = "";
      addAgentDialogVisible.value = true;
    };

    const editAgent = async (agent) => {
      dialogTitle.value = t("proxy.text273"); // 设置标题为编辑代理
      await fetchRuleGroups(); // 请求规则组信息

      try {
        const { data } = await apiService.proxyInfo({
          SProxyId: agent.proxyid,
        });
        const proxy = data.proxy;

        // 填充表单数据
        addAgentForm.proxyId = proxy.proxyid;
        addAgentForm.name = proxy.name;
        addAgentForm.contracter = proxy.contracter;
        addAgentForm.contacterphone = proxy.contacterphone;

        // 转换规则组字符串为数组
        addAgentForm.highLevelGroupIds = proxy.highLevelGroupIds
          ? proxy.highLevelGroupIds.split(",").map((id) => parseInt(id))
          : [];
        addAgentForm.normalLevelGroupIds = proxy.normalLevelGroupIds
          ? proxy.normalLevelGroupIds.split(",").map((id) => parseInt(id))
          : [];
        addAgentForm.lowLevelGroupIds = proxy.lowLevelGroupIds
          ? proxy.lowLevelGroupIds.split(",").map((id) => parseInt(id))
          : [];

        addAgentForm.userId = proxy.userId;
        addAgentForm.status = proxy.status === 10 ? "正常" : "禁用";
        addAgentForm.note = proxy.note || "";

        console.log("编辑代理信息:", addAgentForm);

        // 强制选中规则组
        forceSelectRuleGroups();

        // 打开弹窗
        addAgentDialogVisible.value = true;
      } catch (error) {
        console.error("获取代理信息失败:", error);
      }
    };

    // 强制选中规则组并禁用
    const forceSelectRuleGroups = () => {
      const setDisabledOptions = (groupList, selectedValues) => {
        groupList.forEach((group) => {
          group.disabled = selectedValues.includes(group.rulesGroupID);
        });
      };

      setDisabledOptions(ruleGroups.high, addAgentForm.highLevelGroupIds);
      setDisabledOptions(ruleGroups.normal, addAgentForm.normalLevelGroupIds);
      setDisabledOptions(ruleGroups.low, addAgentForm.lowLevelGroupIds);
    };

    const handlePageChange = (page) => {
      currentPage.value = page;
      fetchData();
    };

    const handleSizeChange = (size) => {
      pageSize.value = size;
      fetchData();
    };

    onMounted(() => {
      fetchUserInformation();
      fetchData();
    });

    return {
      searchForm,
      addAgentForm,
      tableData,
      ruleGroups,
      dialogTitle,
      currentPage,
      pageSize,
      totalEntries,
      addAgentDialogVisible,
      openAddAgentDialog,
      editAgent,
      saveAgent,
      handlePageChange,
      handleSizeChange,
      onSearch,
      goToAgentLinks,
      canAddSubProxy,
    };
  },
};
</script>
<style lang="less" scoped>
.add-button {
  width: 100px;
  height: 32px;
  margin-left: 40px;
  text-align: center;
}

.dialog-footer {
  padding-top: 38px;
  display: flex;
  justify-content: right;
}

.link-button {
  color: #67c23a;
  font-size: 16px;
}

.el-button {
  font-size: 16px !important;
}

.ellipsis-text {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  cursor: pointer;
}

.no-wrap-label .el-form-item__label {
  white-space: nowrap; /* 防止换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
}

.el-select-dropdown__item.is-disabled {
  color: #ccc; /* 设置禁用项颜色 */
  cursor: not-allowed;
}
</style>
